// src/types/index.ts
export interface UserDataRequestParam {
  uid: string;
  userId: string;
  userName: string;
  currentSubscriptionType?: string;
  addOnVerificationMode?: boolean;
  deleteAuthWhenNotJoined: boolean;
}

export interface CreditAdditionRequestParam {
  userId: string;
  creditsToAdd: number;
  source?: "subscription" | "purchase" | "admin";
}

export interface CreditSubtractRequestParam {
  userId: string;
  creditsToSubtract: number;
}

export interface ScriptHelperCreateParam {
  lang: string;
  assistantId: string;
  lastCategoryUpdated: string;
}

export interface ScriptHelperUpdateParam {
  lang: string;
  lastCategoryUpdated: string;
}

export interface NewKeywordHelperUpdateParam {
  userId: string;
  threadId: string;
}

export interface TypoCorrectionHelperUpdateParam {
  userId: string;
  threadId: string;
}

export interface VideoClipSelectorUpdateParam {
  userId: string;
  threadId: string;
}

export interface MetaCompleterCreateParam {
  lang: string;
  assistantId: string;
  lastCategoryUpdated: string;
}

export interface MetaCompleterUpdateParam {
  lang: string;
  lastCategoryUpdated: string;
}

// export interface ScriptHelperRequestParam {
//   userId: string;
//   lang: string;
// }
// export interface MetaCompleterRequestParam {
//   userId: string;
//   lang: string;
// }

export interface CreditUsableRequestParam {
  userId: string;
}

export interface SubscriptionStatusUpdateParam {
  userId: string;
  subscriptionType: string;
}

export interface SubscriptionStatusUpdateWithReceiptParam
  extends SubscriptionStatusUpdateParam {
  extendedJsonData?: unknown;
  appReceiptXml?: string;
}

export interface UpdateMotherboardIdRequestParam {
  userId: string;
  motherboardId: string;
}

export interface DodoCheckoutRequestParam {
  userId: string;
  productCode: string;
  locale?: string;
}

export interface DodoCheckoutResponse {
  checkoutUrl: string;
}

export interface CancelDodoSubscriptionRequestParam {
  userId: string;
}

export interface CancelDodoSubscriptionResponse {
  ok: boolean;
  message: string;
  status: string;
  endsAt: string | null;
}

export interface CreditUsableResponse {
  currentCRD: number;
  currentSCredits: number;
  currentECredits: number;
}

export interface ExpiringCreditItemResponse {
  bucketId: string;
  remaining: number;
  expiresAt: string;
  daysLeft: number;
  source: string;
}

export interface CRDUsableResponse {
  currentCRD: number;
  expiringCredits: ExpiringCreditItemResponse[];
}

export interface NextExpiringCRDResponse {
  expiresAtUtc: string;
  expiresAtUtcMinute: string;
  expiringCRD: number;
}

export interface BillingTransactionItem {
  transactionId: string;
  provider: string | null;
  providerOrderId: string | null;
  providerSubscriptionId: string | null;
  eventType: string | null;
  status: string | null;
  productCode: string | null;
  currency: string | null;
  amountTotal: number | null;
  amountPretax?: number | null;
  amountTax?: number | null;
  creditGranted: number | null;
  creditRevoked: number | null;
  createdAt: string | null;
  updatedAt: string | null;
  processedAt: string | null;
  refundedAt: string | null;
  remainingSubscriptionCRD?: number | null;
  remainingPurchasedCRD?: number | null;
}

export interface BillingTransactionsResponse {
  transactions: BillingTransactionItem[];
  hasMore: boolean;
  nextCursor: string | null;
}

export interface AdminMemberSummaryItem {
  userId: string;
  uid: string;
  userLevel: number;
  billingStatus: string;
  planDisplayName: string;
  crd: number;
  createdAt: string | null;
}

export interface AdminMembersResponse {
  members: AdminMemberSummaryItem[];
  hasMore: boolean;
  nextCursor: string | null;
}

export interface PaymentType {
  amount: number;
  period: number;
  unit: string;
}

export interface UserDataResponse {
  IsJoined: boolean;
  UID: string;
  CreateTime: string;
  WithdrawalTime: string;
  LastCreditIssuedTime: string;
  Email: string;
  IsPartnersAllowed: boolean;
  // Name: string;
  // PhoneNumber: string;
  SubscriptionType: string;
  UserLevel: number;
  HasSubscribed: boolean;
  PlanCode?: string;
  PlanDisplayName?: string;
  BillingStatus?: string;
  BillingRenewAt?: string;
  BillingCancellationScheduled?: boolean;
  SupportChatBlockedUntil?: string;
  SupportChatWarningCount?: number;
  CRD?: number;
  SCredits: number;
  ECredits: number;
  Channels: string[];
}

export interface TextToVideoType {
  theme: string;
  voiceType: VoiceType;
}

export interface BestSeriesType {
  theme: string;
  bests: string[];
  bestsCountForAuto: number;
  entryMode: string;
  bestCountForAuto: number;
  includeOpening: boolean;
  includeClosing: boolean;
  useRanking: boolean;
  voiceType: VoiceType;
}

export interface VideoToVideoType {
  videoUrl: string;
  useFixedSubtitle: boolean;
  fixedSubtitle: string;
  cropStartTime: string;
  cropEndTime: string;
}

export interface VideoTask {
  id: string;
  channel: string;
  taskType: TaskType;
  videoLength: VideoLength;
  status: TaskStatus;
  updatedDateTime: string;
  textToVideo: TextToVideoType;
  bestSeries: BestSeriesType;
  videoToVideo: VideoToVideoType;
}

export enum VideoLength {
  Short = "short",
  Long = "long",
}

export enum TaskType {
  VideoToVideo = "videoToVideo",
  TextToVideo = "textToVideo",
  BestSeries = "bestSeries",
}

export enum TaskStatus {
  Completed = "completed",
  Pending = "pending",
  InProgress = "inProgress",
  Failed = "failed",
  Canceled = "canceled",
}

export enum VoiceType {
  Free = "free",
  Pro = "pro",
}

